import * as React from 'react';
import { getTimeRemaining, getTotalRemainingTime } from './SessionHelper';

interface ISessionTimerProps {
  timeoutDate: Date;
}
interface ISessionTimerState {
  sessionTimeRemaining: number;
}

export class SessionTimer extends React.Component<ISessionTimerProps, ISessionTimerState> {
  interval: NodeJS.Timeout;

  componentDidMount() {
    this.updateSessionTimer();
    this.interval = setInterval(() => {
      this.updateSessionTimer();
    }, 1000);
  }

  componentWillUnmount(): void {
    clearInterval(this.interval);
  }

  updateSessionTimer = () => {
    const timeRemaining = getTotalRemainingTime(this.props.timeoutDate);
    this.setState({
      sessionTimeRemaining: timeRemaining,
    });
  };

  render(): JSX.Element {
    if (!this.state?.sessionTimeRemaining) return <></>;
    const { minutes, seconds } = getTimeRemaining(this.state.sessionTimeRemaining);
    return (
      <div>
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </div>
    );
  }
}
